import { configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'

import { rootReducer } from './rootDuck'
import { featureFlagsApi } from '../../_augmentt/services/featureFlags'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // These should be enabled and reported issues fixed
      serializableCheck: false,
      immutableCheck: false,
    }).concat(featureFlagsApi.middleware),
})

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store)

export default store
